import { Button, Modal, Spacer, TextGroupMedium } from "@cd2/components"
import { IComponentCallback } from "@cd2/tools"
import React from "react"
import { LeadsForm } from "../Pages/CRM/Leads/LeadsForm"
import { useConfirmation } from "./useConfirmation"
import { useSiteAlerts } from "./useSiteAlerts"
import { IRecord } from "../types/schema"

export function useNewLead() {
  const skeem = window.skeem
  const alerts = useSiteAlerts()
  return useConfirmation<{ branch: IRecord<"branches", "name"> }, { id: string } | null>(
    ({ onResolve, data }) => {
      async function handleCreateLead(formData: IComponentCallback<typeof LeadsForm, "onSubmit">) {
        try {
          const mutationData = LeadsForm.getMutationData({ ...formData, branch: data.branch })
          const record = await skeem.mutate({ leads: mutationData })
          alerts.genericSuccess("Lead created")
          onResolve({ id: record.id })
        } catch (error) {
          alerts.genericError("Failed to create lead. Please try again.")
          onResolve(null)
        }
      }

      return (
        <Modal
          onRequestClose={() => onResolve(null)}
          render={() => (
            <div>
              <TextGroupMedium heading="Create new lead" />
              <Spacer />
              <LeadsForm
                onSubmit={handleCreateLead}
                actions={
                  <Button buttonColor="gray" onClick={() => onResolve(null)}>
                    Cancel
                  </Button>
                }
                disableBranchSelection
              />
            </div>
          )}
          isOpen
        />
      )
    },
  )
}
